import React from "react"

import {
  prefetchLenderProfileApprovalRetrieveQuery,
  useLenderProfileApprovalRetrieve,
} from "@boundless/bl-api-client/lender/services"
import { createFileRoute, redirect } from "@tanstack/react-router"

import { ApprovalStatusAlert } from "@/components/approvals/ApprovalStatusAlert"
import {
  FallbackLenderProfileForm,
  LenderProfileForm,
} from "@/components/lender/LenderProfileForm"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"

export const Route = createFileRoute("/_dashboard/lender/profile")({
  component: RouteComponent,
  beforeLoad: ({ context: { hasPermissions } }) => {
    if (!hasPermissions(["lender.view_lenderprofile"])) {
      throw redirect({ to: "/" })
    }
  },
  loader: ({ context: { queryClient } }) => {
    prefetchLenderProfileApprovalRetrieveQuery(queryClient)
  },
})

function RouteComponent() {
  const { data: approval } = useLenderProfileApprovalRetrieve()
  return (
    <Card>
      <CardHeader>
        <CardTitle>Lender Profile</CardTitle>
        <CardDescription></CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-6">
        {approval && <ApprovalStatusAlert approval={approval} />}
        <React.Suspense fallback={<FallbackLenderProfileForm />}>
          <LenderProfileForm />
        </React.Suspense>
      </CardContent>
    </Card>
  )
}
